var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loading-overlay",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-spinner"}),_vm._v(" "),_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-320a2f5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = null
// module chunks = 